import { render, staticRenderFns } from "./SmsView.vue?vue&type=template&id=22602ebf"
import script from "./SmsView.vue?vue&type=script&lang=js"
export * from "./SmsView.vue?vue&type=script&lang=js"
import style0 from "./AppView.css?vue&type=style&index=0&prod&lang=css&external"


/* normalize component */
import normalizer from "!../../../../../usr/local/share/.config/yarn/global/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports